import { effectiveProfileTags } from '../services/profile'
export const AUDIENCE_ACCESS_ORDER = Object.freeze([
  'hcp',
  'partner',
  'staff_us',
  'staff_global',
])

export const AUDIENCE_ACCESS_DEFINITIONS = Object.freeze({
  hcp: Object.freeze({
    sourceName: 'HCP',
    icon: 'audience-hcp',
    labelKey: 'audience_access_hcp',
  }),
  partner: Object.freeze({
    sourceName: 'Partners',
    icon: 'audience-partner',
    labelKey: 'audience_access_partner',
  }),
  staff_us: Object.freeze({
    sourceName: 'Staff US',
    icon: 'audience-staff-us',
    labelKey: 'audience_access_staff_us',
  }),
  staff_global: Object.freeze({
    sourceName: 'Staff Global (Ex-US)',
    icon: 'audience-staff-global',
    labelKey: 'audience_access_staff_global',
  }),
})

const SOURCE_NAME_TO_AUDIENCE = new Map(
  AUDIENCE_ACCESS_ORDER.map((audience) => [
    AUDIENCE_ACCESS_DEFINITIONS[audience].sourceName.toLowerCase(),
    audience,
  ])
)

const toArray = (value) => {
  if (!value) return []
  if (Array.isArray(value?.data)) return value.data
  return Array.isArray(value) ? value : [value]
}

const getTagValue = (tag, field) => tag?.attributes?.[field] ?? tag?.[field]

const getTagName = (tag) => {
  if (typeof tag === 'string') return tag.trim()

  return `${getTagValue(tag, 'name') || getTagValue(tag, 'title') || getTagValue(tag, 'label') || ''}`.trim()
}

const getTagType = (tag) => `${getTagValue(tag, 'tag_type') || ''}`.trim().toLowerCase()

export function normalizeAudienceAccess(value) {
  const normalized = new Set()

  toArray(value).forEach((entry) => {
    if (typeof entry === 'string' && AUDIENCE_ACCESS_DEFINITIONS[entry]) {
      normalized.add(entry)
      return
    }

    const tagType = getTagType(entry)
    const audience = SOURCE_NAME_TO_AUDIENCE.get(getTagName(entry).toLowerCase())

    if (audience && (!tagType || tagType === 'industry')) {
      normalized.add(audience)
    }
  })

  return AUDIENCE_ACCESS_ORDER.filter((audience) => normalized.has(audience))
}

export function getContentAudiences(content) {
  const explicitAudiences = normalizeAudienceAccess(content?.audiences)
  return explicitAudiences.length ? explicitAudiences : normalizeAudienceAccess(content?.tags)
}

export function getAudienceViewerType(user) {
  const tagNames = new Set(toArray(effectiveProfileTags(user)).map((tag) => getTagName(tag).toLowerCase()).filter(Boolean))

  if (tagNames.has(AUDIENCE_ACCESS_DEFINITIONS.staff_us.sourceName.toLowerCase())
    || tagNames.has(AUDIENCE_ACCESS_DEFINITIONS.staff_global.sourceName.toLowerCase())) return 'staff'
  if (tagNames.has(AUDIENCE_ACCESS_DEFINITIONS.partner.sourceName.toLowerCase())) return 'partner'
  if (tagNames.has(AUDIENCE_ACCESS_DEFINITIONS.hcp.sourceName.toLowerCase())) return 'hcp'

  return 'unknown'
}

export function canViewAudienceAccessIndicators(user) {
  return ['staff', 'partner'].includes(getAudienceViewerType(user))
}
